import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Table } from "antd";
import { toJS, runInAction, action } from "mobx";
import { columns } from "./data";
import TableText from "../../table/TableText";

const totalIndex = [];

@inject("store")
@observer
class App extends Component {
  @action
  onChange = (name, value, i) => {
    let data = toJS(this.props.store.kpifollow.customers);
    data[i][name] = value;
    this.props.store.kpifollow.customers = data;
  };

  render() {
    const { data, loading, customers } = this.props.store.kpifollow;
    const columns = [
      {
        title: "客源情况MTD",
        align: "center",
        children: [
          {
            title: "",
            dataIndex: `name`,
            key: `name`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "text",
                name: `name`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
          {
            title: "MTD",
            dataIndex: `mtd`,
            key: `mtd`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `mtd`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
      {
        title: "未来7天远期房态",
        align: "center",
        children: [
          {
            title: "日期",
            dataIndex: `date`,
            key: `date`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "input",
                name: `date`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
          {
            title: "出租率",
            dataIndex: `occ`,
            key: `occ`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputPercent",
                name: `occ`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
          {
            title: "已售房",
            dataIndex: `sold`,
            key: `sold`,
            width: 150,
            align: "center",
            render: (text, record, index) => {
              const props = {
                text,
                index,
                type: "inputNumber",
                name: `sold`,
                onChange: this.onChange,
                totalIndex,
              };
              return <TableText data={props} />;
            },
          },
        ],
      },
    ];

    return (
      <div className="">
        <div>
          {/* <Row className="secondary_title">客源情况MTD</Row> */}
          <Table
            columns={columns}
            dataSource={toJS(customers)}
            size="middle"
            bordered
            pagination={false}
            className="content"
            rowKey={"r.name"}
          />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/Table1.js